import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/market`;

export async function getMarketIndices(names) {
  const query = Array.isArray(names) ? names.join(",") : "";
  const res = await apiFetch(`${BASE_URL}/indices?names=${encodeURIComponent(query)}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
